module.exports = __webpack_public_path__ + "aee04890b5a772bfc35b3ae7c5d1cd29.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GG.svg
// module id = azWn
// module chunks = 0